export { default as FaqDynamic } from "./faqDynamic";
export { default as OurPartners } from "./OurPartners";
export { default as PortfolioSectionHomePage } from "./portfolio/PortfolioSectionHomePage";
export { default as ServicesC } from "./servicesC";
export { default as TransformBrand } from "./TransformBrand";
